import {auth} from '@resurs-internal/rb-app-api/features/auth/auth';
import {decodeAccessToken} from '@resurs-internal/rb-app-api';
import {useNavigate} from '@tanstack/react-router';
import {useEffect} from 'react';

const AUTH_CHANNEL = 'auth';

const getLoginTag = () => decodeAccessToken(auth.state?.token)?.loginTag;

export const broadcastLogin = () => {
  const bc = new BroadcastChannel(AUTH_CHANNEL);
  bc.postMessage({type: 'login', loginTag: getLoginTag()});
  bc.close();
};

export const useCrossTabAuthListener = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const bc = new BroadcastChannel(AUTH_CHANNEL);
    bc.onmessage = (event) => {
      if (
        event.data?.type === 'login' &&
        event.data?.loginTag !== getLoginTag() &&
        auth.state?.isLoggedIn
      ) {
        navigate({to: '/logout'});
      }
    };
    return () => bc.close();
  }, [navigate]);
};
